
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_2"}},[_c('path',{staticClass:"st2",attrs:{"d":"M187.1 58c-3.3-1.9-6.6-2.4-9.7-1.8L182 48c4.9-8.6 1.5-19.8-7.5-25-9-5.1-20.4-2.3-25.3 6.3l-56.7 99.9c-4.4 7.8-4.7 38.6-4.7 42 0 .9.5 1.7 1.3 2.2.4.2.8.3 1.2.3.4 0 .9-.1 1.3-.4 3-1.8 29.3-17.8 33.7-25.6l45.4-79.9c2.6-4.6 7.2-9.4 13.8-5.6 6.5 3.7 4.8 9.8 2.2 14.3L163 118.2l4.3 2.5L191 79c5.3-8.8 3.8-16.7-3.9-21zM121 145.4c-2.6 4.5-17 14.5-28.1 21.4.3-13.1 1.4-30.6 4-35.1l56.7-99.9c2.3-4.1 6.7-6.4 11.3-6.4 2.4 0 4.9.6 7.2 1.9 6.6 3.8 9.2 11.9 5.6 18.2l-11.3 19.9-45.4 80zM72.1 171c-3.8.6-7.6-1.1-9.5-4.2-2.2-3.6-1.6-8.2 1.5-11.3.9-.9 1-2.3.2-3.3s-2.1-1.3-3.2-.6c-6.5 3.7-14.1 3.7-18.2.1-2.4-2.1-3.7-5.9-3.7-10 .1-4 1.5-7.9 4-11.3 1.5-1.3 3-2.8 4.3-4.4.8-1 .7-2.4-.2-3.3-.9-.9-2.3-1-3.3-.2-1.6 1.3-3.1 2.8-4.3 4.4-4.7 3.8-10.4 5.4-15.3 4-10.1-2.8-11.9-16.9-12.1-18.5-1-9.4 3.6-20.5 11.6-28.4 6.2-6 13.4-9 19.8-8.2 7.4 1 12.9 6.8 16.2 11.6.8 1.1 2.3 1.4 3.5.6 1.1-.8 1.4-2.3.6-3.5-3.8-5.5-10.3-12.4-19.6-13.6-7.9-1-16.6 2.4-23.9 9.6-9.1 8.9-14.3 21.6-13.1 32.5.3 3.2 2.7 19.2 15.8 22.8 4 1.1 8.2.8 12.2-.6-.7 2.1-1 4.3-1.1 6.5-.1 5.6 1.8 10.7 5.3 13.8 4.2 3.8 10.7 4.9 17.2 3.2-.9 3.6-.4 7.5 1.6 10.7 2.5 4.2 7.3 6.7 12.2 6.7.8 0 1.6-.1 2.4-.2 1.4-.2 2.3-1.5 2.1-2.9-.3-1.3-1.6-2.2-3-2z"}})])])
          )
        }
      }
    